module.exports = __webpack_public_path__ + "static/img/压差旁通.3a4fb27a.png";